import { msgs } from "../define";

/**
 * "Open business / Close business" (开始营业 / 结束营业) — the cash drawer session framed for the counter — plus the
 * salon rule and the onboarding wizard's e-mail check.
 */
export const drawer = msgs({
  en: {
    "biz.pill.open": "Open · since {time} · {name}",
    "biz.pill.closed": "Not open for business",
    "biz.pill.title": "Open/close business (cash drawer)",
    "biz.open": "Open business",
    "biz.close": "Close business",
    "biz.later": "Later",
    "biz.banner": "The business isn't open yet. Cash can only be taken after you open it.",
    "biz.banner.optional": "The business isn't open yet (cash drawer not counted).",
    "biz.openModal.body": "Count the cash in the drawer and enter it as the opening float. Cash sales are counted against it when you close business.",
    "biz.openModal.optional": "Recommended: your salon lets cash be taken without it, but the cash then isn't counted in a drawer session.",
    "biz.openModal.beforeCash": "Open business first to take this cash payment — the payment continues right after.",
    "biz.openModal.float": "Opening cash float",
    "biz.openModal.lastClose": "Last close counted {amount}.",
    "biz.openModal.meta": "{date} · {branch} · {name}",
    "biz.openModal.readOnly": "You can't open the business. Please ask the {roles} to open it.",
    "biz.roles.or": " or ",
    "biz.opened": "Business opened",
    "biz.closeModal.expected": "Expected cash in drawer",
    "biz.closeModal.counted": "Counted cash",
    "biz.closeModal.variance": "Difference",
    "biz.closeModal.even": "The count matches.",
    "biz.closeModal.note": "Note (required when there is a difference)",
    "biz.closeModal.takings": "Today's takings by method",
    "biz.closeModal.noTakings": "No payments yet in this session.",
    "biz.closeModal.confirm": "Close business",
    "biz.closed.title": "Business closed",
    "biz.closed.body": "The cash drawer is closed. The day itself isn't locked — review and lock it in the daily close.",
    "biz.closed.viewClose": "View daily close",
    "biz.close.notInSession": "Cash not in a drawer session",
    "biz.close.notInSessionHint": "Taken while “Cash payments require open business” was off and the business wasn't open. Count it separately.",
    "biz.rule.label": "Cash payments require open business (an open cash drawer)",
    "biz.rule.hint": "Recommended. When off, opening business is only suggested; cash taken while it isn't open is recorded outside a drawer session and listed separately in the daily close.",
    "biz.notRequired": "Business isn't open. By your salon's setting this cash is recorded outside a drawer session.",
    "verify.wiz.checking": "Checking…",
    "verify.wiz.ok": "Email confirmed. You can open the dashboard now.",
    "verify.wiz.notYet": "We haven't received the confirmation yet — please click the link in the email.",
    "verify.wiz.auto": "This page updates by itself as soon as you confirm (also from another tab).",
  },
  zh: {
    "biz.pill.open": "营业中 · 开始于 {time} · {name}",
    "biz.pill.closed": "未开始营业",
    "biz.pill.title": "营业 / 钱箱",
    "biz.open": "开始营业",
    "biz.close": "结束营业",
    "biz.later": "稍后",
    "biz.banner": "还未开始营业，开始营业后才能收现金。",
    "biz.banner.optional": "还未开始营业（钱箱未清点）。",
    "biz.openModal.body": "请清点钱箱里的现金，填写为开班备用金。结束营业时会按此核对现金。",
    "biz.openModal.optional": "建议开始营业：店铺设置允许不开班收现金，但这些现金不会计入钱箱班次。",
    "biz.openModal.beforeCash": "请先开始营业再收这笔现金，开始后付款会自动继续。",
    "biz.openModal.float": "开班备用金",
    "biz.openModal.lastClose": "上次结束营业清点：{amount}。",
    "biz.openModal.meta": "{date} · {branch} · {name}",
    "biz.openModal.readOnly": "请联系{roles}开始营业。",
    "biz.roles.or": "/",
    "biz.opened": "已开始营业",
    "biz.closeModal.expected": "钱箱应有现金",
    "biz.closeModal.counted": "实点现金",
    "biz.closeModal.variance": "差额",
    "biz.closeModal.even": "清点金额一致。",
    "biz.closeModal.note": "说明（有差额时必填）",
    "biz.closeModal.takings": "今日按付款方式收款",
    "biz.closeModal.noTakings": "本班次还没有收款。",
    "biz.closeModal.confirm": "确认结束营业",
    "biz.closed.title": "已结束营业",
    "biz.closed.body": "钱箱已关班。当天尚未锁定，请在日结中核对并锁定。",
    "biz.closed.viewClose": "查看日结",
    "biz.close.notInSession": "未计入钱箱班次的现金",
    "biz.close.notInSessionHint": "在“收现金必须先开始营业”关闭且未开始营业时收取，请单独清点。",
    "biz.rule.label": "收现金必须先开始营业",
    "biz.rule.hint": "建议开启。关闭后开始营业只是建议；未开始营业时收的现金不计入钱箱班次，并在日结中单独列出。",
    "biz.notRequired": "未开始营业。按店铺设置，这笔现金将不计入钱箱班次。",
    "verify.wiz.checking": "正在检查…",
    "verify.wiz.ok": "邮箱已确认，现在可以进入控制台。",
    "verify.wiz.notYet": "还没有收到确认，请点邮件里的链接",
    "verify.wiz.auto": "确认后此页面会自动更新（在其他标签页确认也可以）。",
  },
  ms: {
    "biz.pill.open": "Dibuka · sejak {time} · {name}",
    "biz.pill.closed": "Belum buka perniagaan",
    "biz.pill.title": "Buka/tutup perniagaan (laci tunai)",
    "biz.open": "Buka perniagaan",
    "biz.close": "Tutup perniagaan",
    "biz.later": "Nanti",
    "biz.banner": "Perniagaan belum dibuka. Tunai hanya boleh diterima selepas dibuka.",
    "biz.banner.optional": "Perniagaan belum dibuka (laci tunai belum dikira).",
    "biz.openModal.body": "Kira tunai dalam laci dan masukkan sebagai apungan pembukaan. Jualan tunai dikira berbandingnya semasa tutup perniagaan.",
    "biz.openModal.optional": "Disyorkan: salun anda membenarkan tunai tanpanya, tetapi tunai itu tidak dikira dalam sesi laci.",
    "biz.openModal.beforeCash": "Buka perniagaan dahulu untuk menerima bayaran tunai ini — bayaran diteruskan sejurus selepas itu.",
    "biz.openModal.float": "Apungan tunai pembukaan",
    "biz.openModal.lastClose": "Tutupan terakhir dikira {amount}.",
    "biz.openModal.meta": "{date} · {branch} · {name}",
    "biz.openModal.readOnly": "Anda tidak boleh membuka perniagaan. Sila minta {roles} membukanya.",
    "biz.roles.or": " atau ",
    "biz.opened": "Perniagaan dibuka",
    "biz.closeModal.expected": "Tunai dijangka dalam laci",
    "biz.closeModal.counted": "Tunai dikira",
    "biz.closeModal.variance": "Perbezaan",
    "biz.closeModal.even": "Kiraan sepadan.",
    "biz.closeModal.note": "Nota (wajib jika ada perbezaan)",
    "biz.closeModal.takings": "Kutipan hari ini mengikut kaedah",
    "biz.closeModal.noTakings": "Belum ada bayaran dalam sesi ini.",
    "biz.closeModal.confirm": "Tutup perniagaan",
    "biz.closed.title": "Perniagaan ditutup",
    "biz.closed.body": "Laci tunai ditutup. Hari itu belum dikunci — semak dan kunci dalam tutupan harian.",
    "biz.closed.viewClose": "Lihat tutupan harian",
    "biz.close.notInSession": "Tunai bukan dalam sesi laci",
    "biz.close.notInSessionHint": "Diterima semasa “Bayaran tunai memerlukan perniagaan dibuka” dimatikan dan perniagaan belum dibuka. Kira secara berasingan.",
    "biz.rule.label": "Bayaran tunai memerlukan perniagaan dibuka (laci tunai dibuka)",
    "biz.rule.hint": "Disyorkan. Jika dimatikan, membuka perniagaan hanya cadangan; tunai yang diterima semasa belum dibuka direkod di luar sesi laci dan disenaraikan berasingan dalam tutupan harian.",
    "biz.notRequired": "Perniagaan belum dibuka. Mengikut tetapan salun, tunai ini direkod di luar sesi laci.",
    "verify.wiz.checking": "Menyemak…",
    "verify.wiz.ok": "E-mel disahkan. Anda boleh membuka papan pemuka sekarang.",
    "verify.wiz.notYet": "Pengesahan belum diterima — sila klik pautan dalam e-mel.",
    "verify.wiz.auto": "Halaman ini dikemas kini sendiri sebaik sahaja anda mengesahkan (juga dari tab lain).",
  },
});
